import TemplatesActionTypes from 'redux/template/types';
import { EMAIL, DOCUMENT } from 'utils/constants';

function sortTemplates(templates, payload) {
  const { template, type, explicitType } = payload;
  const templatesClone = { ...templates };
  if (template.content.length !== 0) {
    if (type === EMAIL) {
      if (explicitType === 'user') {
        templatesClone.email.user = { loading: false, ...template };
      } else {
        templatesClone.email.system = { loading: false, ...template };
      }
    } else if (type === DOCUMENT) {
      if (explicitType === 'user') {
        templatesClone.document.user = { loading: false, ...template };
      } else {
        templatesClone.document.system = {
          loading: false,
          ...template,
        };
      }
    } else {
      if (explicitType === 'user') {
        templatesClone.sms.user = { loading: false, ...template };
      } else {
        templatesClone.sms.system = { loading: false, ...template };
      }
    }
  } else {
    if (type === EMAIL) {
      if (explicitType === 'user') {
        templatesClone.email.user = {
          ...templatesClone.email.user,
          loading: false,
        };
      } else {
        templatesClone.email.system = {
          ...templatesClone.email.system,
          loading: false,
        };
      }
    } else if (type === DOCUMENT) {
      if (explicitType === 'user') {
        templatesClone.document.user = {
          ...templatesClone.document.user,
          loading: false,
        };
      } else {
        templatesClone.document.system = {
          ...templatesClone.document.system,
          loading: false,
        };
      }
    } else {
      if (explicitType === 'user') {
        templatesClone.sms.user = {
          ...templatesClone.sms.user,
          loading: false,
        };
      } else {
        templatesClone.sms.system = {
          ...templatesClone.sms.system,
          loading: false,
        };
      }
    }
  }
  return templatesClone;
}

function removeDeletedTemplates(templates, payload) {
  const { id, type } = payload;
  const templatesClone = { ...templates };
  if (type === EMAIL) {
    const userEmailTemplateClone = [...templatesClone.email.user.content];
    templatesClone.email.user.content = userEmailTemplateClone.filter(
      (template) => template.id !== id
    );
  } else if (type === DOCUMENT) {
    const userDocTemplateClone = [...templatesClone.document.user.content];
    templatesClone.document.user.content = userDocTemplateClone.filter(
      (template) => template.id !== id
    );
  } else {
    const userSmsTemplateClone = [...templatesClone.sms.user.content];
    templatesClone.sms.user.content = userSmsTemplateClone.filter(
      (template) => template.id !== id
    );
  }
  return templatesClone;
}

const initialState = {
  templates: {
    email: {
      user: {
        loading: true,
        content: [],
      },
      system: {
        loading: true,
        content: [],
      },
    },
    document: {
      user: {
        loading: true,
        content: [],
      },
      system: {
        loading: true,
        content: [],
      },
    },
    sms: {
      user: {
        loading: true,
        content: [],
      },
      system: {
        loading: true,
        content: [],
      },
    },
  },
  updatingTemplate: false,
  fetchingSingleTemplateLoading: false,
  singleTemplate: null,
  error: null,
};

function templatesReducer(state = initialState, { type, payload }) {
  switch (type) {
    // ALL TEMPLATES
    case TemplatesActionTypes.FETCH_TEMPLATES_SUCCESS:
      return {
        ...state,
        templates: sortTemplates(state.templates, payload),
      };
    case TemplatesActionTypes.FETCH_TEMPLATES_FAILURE:
      return {
        ...state,
      };

    // EMAIL
    case TemplatesActionTypes.START_FETCH_EMAIL_USER_TEMPLATES:
      return {
        ...state,
        emailUserTemplateLoading: true,
        updatingTemplate: false,
      };
    case TemplatesActionTypes.UPDATE_EMAIL_TEMPLATE_START:
      return {
        ...state,
        updatingTemplate: true,
      };
    case TemplatesActionTypes.START_FETCH_EMAIL_SYSTEM_TEMPLATES:
      return {
        ...state,
      };

    // DOCUMENT
    case TemplatesActionTypes.START_FETCH_DOCUMENT_USER_TEMPLATES:
      return {
        ...state,
        updatingTemplate: false,
      };
    case TemplatesActionTypes.UPDATE_DOCUMENT_TEMPLATE_START:
      return {
        ...state,
        updatingTemplate: true,
      };
    case TemplatesActionTypes.START_FETCH_DOCUMENT_SYSTEM_TEMPLATES:
      return {
        ...state,
      };

    // SMS
    case TemplatesActionTypes.START_FETCH_SMS_USER_TEMPLATES:
      return {
        ...state,
      };
    case TemplatesActionTypes.START_FETCH_SMS_SYSTEM_TEMPLATES:
      return {
        ...state,
      };
    case TemplatesActionTypes.DELETE_TEMPLATES_SUCCESS:
      return {
        ...state,
        templates: removeDeletedTemplates(state.templates, payload),
      };

    // SINGLE TEMPLATE
    case TemplatesActionTypes.FETCH_SINGLE_TEMPLATE:
      return {
        ...state,
        fetchingSingleTemplateLoading: true,
      };
    case TemplatesActionTypes.FETCH_SINGLE_TEMPLATE_SUCCESS:
      return {
        ...state,
        fetchingSingleTemplateLoading: false,
        singleTemplate: payload,
      };
    case TemplatesActionTypes.FETCH_SINGLE_TEMPLATE_FAILURE:
      return {
        ...state,
        fetchingSingleTemplateLoading: false,
        error: payload,
      };
    default:
      return state;
  }
}

export default templatesReducer;
